import GroupMembersContainer from './GroupMembersContainer';

export default GroupMembersContainer;
